import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const CategoryService = {}


CategoryService.getCategory = function (params) {
	 
	 let offset = (params-1)*10;
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-category',
		method: 'get',
        params: {
            'offset' : offset
        }
	})
}; 

CategoryService.createCategory = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/create-category`,
		method: 'post',
        data: data

	})
};

CategoryService.updateCategory = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/edit-category`,
		method: 'post',
        data: data
	})
};


export default CategoryService;